module.exports = __webpack_public_path__ + "static/media/student.7bbffb9a.png";